import styled from 'styled-components';

export const Input = styled.input`
    display: inline-block;
    font-size: 20px;
    box-sizing: border-box;
    transition: 0.5s;
    background: #fff;
    width: 340px;
    height: 50px;
    border: none;
    outline: none;
    padding: 0 25px;
    border-radius: 25px;
`;

export const Button = styled.button`
    background: transparent;
    border: none;
`;

export const Wrapper = styled.form`
    display: flex;
    align-items: center;
`;
